import { Ref, SetupContext } from '@vue/composition-api';
import { AnyHighlightComponent } from '../model';

type PropType<TObj, TProp extends keyof TObj> = TObj[TProp];

export interface UseHighlightsInput<T extends AnyHighlightComponent> {
	doInput(_: Partial<T>): void;
	doMetaInput(_: Partial<PropType<T, 'meta'>>): void;
}

export function useHighlightsInput<T extends AnyHighlightComponent>(ctx: SetupContext, item: Ref<T>): UseHighlightsInput<T> {
	const doInput = (_: Partial<T>): void => {
		ctx.emit('input', { ...item.value, ..._ });
	};

	const doMetaInput = (_: Partial<PropType<T, 'meta'>>): void => {
		const meta = { ...item.value.meta, ..._ };
		ctx.emit('input', { ...item.value, meta });
	};

	return {
		doInput,
		doMetaInput,
	};
}
